import toArray from 'lodash/toArray';
import { createSelector } from 'reselect';
import UserDatabases from '@Services/UserDatabases';
import AppStorage from '@Services/AppStorage';
import { eachHierarchy } from '@Hooks/LibraryInitialization/MoreUnderscore';
import { batchModalReducerKey } from './BatchModalConstants';

export const batchModal = (state) => {
  return state.get(batchModalReducerKey);
};

export const batchFile = (state) => {
  return batchModal(state).get('batchFile');
};

export const listOfContexts = () => {
  return UserDatabases && UserDatabases.getUserSearchContexts();
};

export const overwriteOptions = (state) => {
  return batchModal(state).get('overwriteOptions');
};

export const currentStructureOptions = (state) => {
  return batchModal(state).get('currentStructureOptions');
};

export const searchContext = () => {
  return AppStorage && AppStorage.instance.get('qbSearchDB');
};

// eslint-disable-next-line no-shadow
export const structures = createSelector([batchFile], (batchFile) => {
  if (!batchFile) {
    return [];
  }

  let result = [];
  const facts = toArray(batchFile.queries);

  eachHierarchy(
    facts,
    (fact) => {
      if (fact && fact.structures) {
        result = result.concat(fact.structures);
      }
    },
    null,
    { children: 'facts' }
  );

  return result;
});
